import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { Kurultai } from '../../components/kurultai'; 

const KurultaiPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Курултай</title>
            </Helmet>
            <Kurultai/>
        
        </>
    );
};

export default KurultaiPage
